import React from "react";
import ImgSafraLink from "assets/img/safra-link-logo.svg";

export function HeaderSafraLinkLogo() {
  return (
    <div
      className="logo-header-container"
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        maxWidth: "100%",
      }}
    >
      <img
        className="logo-safral1"
        src={ImgSafraLink}
        style={{ height: "50px", width: "135px" }}
        alt="SafraLink Logo"
      />
    </div>
  );
}